import React from 'react'
import { type StripeElements, type Stripe, type StripeElementsOptions } from '@stripe/stripe-js'
import { Elements, type PaymentElementProps } from '@stripe/react-stripe-js'

import { AblefyStripePaymentElement } from 'shop/components/ablefy-stripe-element/AblefyStripePaymentElement'

interface PaymentElementExtendedProps extends PaymentElementProps {
  setStripeElements: (stripeElements: StripeElements) => void
  setStripeClient: (stripeClient: Stripe) => void
  withoutElements?: boolean
}

interface Props {
  options: StripeElementsOptions
  stripePromise: Promise<Stripe>
  elementProps: PaymentElementExtendedProps
  dataTestId: string
}

export const AblefyStripeElementProvider = ({ stripePromise, options, elementProps, dataTestId }: Props) => (
  <div data-testid={dataTestId}>
    <Elements stripe={stripePromise} options={options}>
      <AblefyStripePaymentElement {...elementProps} />
    </Elements>
  </div>
)
